import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import makeSense from 'images/content/1-1-570x599.jpeg'

const NinthSection = () => {
    return (
        <div className='flex flex-col lg:flex-row items-center md:justify-between gap-8'>
            <div className='min-w-lg min-h-lg'>
                <img src={makeSense} alt='plans' />
            </div>
            <div className='w-full max-w-xl space-y-4'>
                <div className='text-2xl sm:text-4xl font-bold'>Which Health Insurance Plan is Best for Me?</div>
                <ul className='sm:text-lg space-y-4'>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> We leverage what you self-pay for medical services. You end up paying much less than what insurance companies pay out.</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> We negotiate procedures and services from healthcare providers and treatment facilities within Multi-Plan on your behalf. So, if you are self-paying, you save up to 80 percent when you use a provider that is in the network.</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> PHCS Multiplan is the largest healthcare PPO network in the country.</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> You choose any doctor In network.</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Our plans pay out benefits based on all benefits schedules regardless if the benefit exceeds your discounted price. You simply pay the remaining balance.</li>
                    <li className='flex'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 text-secondary' /> Use Healthcare Bluebook, a simple online tool, to help you find the best care and price for your procedure in your local area.</li>
                </ul>
            </div>
        </div>
    );
}

export default NinthSection;
